import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import classNames from 'classnames';

import AnonymousRequired from 'components/AnonymousRequired';
import Logo from 'components/Logo';
import Link from 'components/Link';
import Warning from 'components/Warning';

import {FORGOT_PASSWORD} from 'config/urls';
import {selectLogoutMessage} from 'ducks/auth';

import LoginForm from './LoginForm';

import './styles.css';

class LoginPage extends React.Component<any> {
  render() {
    const {logoutMessage} = this.props;

    return (
      <main className="LoginPage">
        <section className="content">
          <Logo
            className={classNames('Logo', {
              hasLogoutMessage: !_.isNil(logoutMessage)
            })}
            white={true}
          />
          {logoutMessage && <Warning>{logoutMessage}</Warning>}
          <LoginForm className="form">
            <Link className="forgottenPassword" to={FORGOT_PASSWORD}>
              I've forgotten my password
            </Link>
          </LoginForm>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    logoutMessage: selectLogoutMessage(state)
  };
};

export default connect(mapStateToProps)(AnonymousRequired(LoginPage));
